import P from '../../pages';
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import FormHeader from './FormHeader'
import Redirector from './Redirector'
import Button from 'react-bootstrap/lib/Button'
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import ButtonGroup from './ButtonGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Info from 'react-icons/lib/fa/info-circle';
import ProfileElementField from './ProfileElementField';
import CustomFormGroup from './CustomFormGroup';
import { validator, fieldsToValidate, pageValid, executeValidations, shouldValidateProfileElement, toggleValidations } from '../../validator';
import { generateProfileElementObject, setProfileElementsFromState, handleSelection, changeState } from '../../utilities';

class Diet extends React.Component {
  constructor(props){
    super(props);
    let hostDietRestrictions = setProfileElementsFromState(this.props.profileElements, '', 'service', 'host_diet_restrictions')
    let validateHostDietRestrictions = shouldValidateProfileElement(this, 'host_diet_restrictions')
    let hostDietRestrictionsDetails = setProfileElementsFromState(this.props.profileElements, '', 'service', 'host_diet_restrictions_details')
    let validateHostDietRestrictionsDetails = hostDietRestrictions && validateHostDietRestrictions
    this.state = {
      catering: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,[],'service','catering'),
      cateringDetails: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','service','catering_details'),
      hostDietRestrictions: { val: hostDietRestrictions, validationKey: validateHostDietRestrictions ? 'profile_elements_service_host_diet_restrictions' : ''},
      hostDietRestrictionsDetails: { val: hostDietRestrictionsDetails, validationKey: validateHostDietRestrictionsDetails ? 'profile_elements_service_host_diet_restrictions_details' : '' },
      typicalMeal: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','service','typical_meal'),
      cateringSelections: this.props.localProfileElements.elements.service.catering_selections,
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.handleCatering = this.handleCatering.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    if (id == 'hostDietRestrictions'){
      toggleValidations(this, String(val) == 'true', 'host_diet_restrictions', 'hostDietRestrictionsDetails', 'profile_elements_service_host_diet_restrictions_details')
    }
    changeState(this, id, val)
  }

  handleCatering(e){
    this.changeState('catering', handleSelection(this.state.catering.val, e.target.value))
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      service: {
        catering: this.state.catering.val,
        catering_details: this.state.cateringDetails.val,
        typical_meal: this.state.typicalMeal.val,
        host_diet_restrictions: this.state.hostDietRestrictions.val,
        host_diet_restrictions_details: this.state.hostDietRestrictionsDetails.val
      }
    });
  }

  render() {
    const thisPage = P.DIET_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const diets = this.props.content.pages.diet.diets;
    const infoArray = [
      diets.halal.info,
      diets.vegetarian.info,
      diets.vegan.info,
      diets.kosher.info,
      diets.gluten_free.info,
      diets.other.info
    ];

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.diet.title} icon={<Info />}/>

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={`${formatMessage(defaultMessages.clientHostPagesDietLabelsCatering)}:`}
                setName='catering'
                type='checkbox'
                checkBoxStyle='checkbox'
                info={infoArray}
                controlFunc={this.handleCatering}
                options={this.state.cateringSelections}
                valid={this.state.catering.valid}
                selectedOptions={this.state.catering.val} />
            }
            elementName='catering' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.cateringDetails.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesDietLabelsCateringDetails)}</ControlLabel>
                <FormControl
                  type="text"
                  id='cateringDetails'
                  componentClass="textarea"
                  style={{width: '100%'}}
                  defaultValue={this.state.cateringDetails.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='catering_details' />

          <ProfileElementField
            childComponent={
              <div>
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesDietLabelsHostDietRestrictions)}
                  setName={'hostDietRestrictions'}
                  type={'radio'}
                  checkBoxStyle={'radio-inline'}
                  controlFunc={e => this.changeState('hostDietRestrictions', e.target.value == 'true')}
                  options={[
                    [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                    [formatMessage(defaultMessages.clientCommonNegative), 'false']
                  ]}
                  valid={this.state.hostDietRestrictions.valid}
                  selectedOptions={[String(this.state.hostDietRestrictions.val)]} />
                {
                  this.state.hostDietRestrictions.val &&
                  <CustomFormGroup valid={this.state.hostDietRestrictionsDetails.valid}>
                    <FormControl
                      type="text"
                      id={'hostDietRestrictionsDetails'}
                      componentClass="input"
                      style={{width: '100%'}}
                      placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                      defaultValue={this.state.hostDietRestrictionsDetails.val}
                      onChange={e => this.changeState(e.target.id, e.target.value)} />
                  </CustomFormGroup>
                }
              </div>
            }
            elementName='host_diet_restrictions' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.typicalMeal.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesDietLabelsTypicalMeal)}</ControlLabel>
                <FormControl
                  type="text"
                  id='typicalMeal'
                  style={{width: '100%'}}
                  componentClass="textarea"
                  placeholder=""
                  defaultValue={this.state.typicalMeal.val}
                  onChange={e => this.changeState(e.target.id, e.target.value)} />
              </CustomFormGroup>
            }
            elementName='typical_meal' />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    );
  }
}

Diet.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Diet);
